import { useTranslation } from 'react-i18next'

import { useSegmentFilterContext } from './context'
import { Button } from '@/Atomic/Molecules/Button'
import { FeatureFlags } from '@/Data/const'
import { useFeatureFlags } from '@/hooks/useFeatureFlagHandler'

export const SegmentFilterButton: React.FC = () => {
  const { t } = useTranslation()
  const { openFilterModal } = useSegmentFilterContext()
  const { isEnabled } = useFeatureFlags()

  if (!isEnabled(FeatureFlags.SHOW_SEGMENT_FILTER)) {
    return null
  }

  return (
    <Button
      title={t('common.filter.title', 'Filter')}
      icon="filter"
      variant="outlined"
      onClick={openFilterModal}
    />
  )
}
